import React, { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';

export const SideNav = React.forwardRef<HTMLElement, PropsWithChildren<{}>>(
  (props, ref) => {
    return (
      <nav ref={ref} className="sidenav">
        <section className="sidenav-content">{props.children}</section>
      </nav>
    );
  }
);

type SideNavLinkProps = PropsWithChildren<{
  routeTo: string;
  exact?: boolean;
}>;

export const SideNavLink = React.forwardRef<
  HTMLAnchorElement,
  SideNavLinkProps
>((props, ref) => {
  const { children, exact, routeTo } = props;
  return (
    <NavLink
      ref={ref}
      className="nav-link"
      to={routeTo}
      activeClassName="active"
      exact={exact}>
      {children}
    </NavLink>
  );
});

export const NavGroup = React.forwardRef<HTMLElement, PropsWithChildren<{}>>(
  (props, ref) => {
    return (
      <section ref={ref} className="nav-group">
        {props.children}
      </section>
    );
  }
);

export const NavGroupTitle: React.FunctionComponent<React.PropsWithChildren<{}>> = (props) => {
  return (
    <>
      <input type="checkbox" />
      <label>{props.children}</label>
    </>
  );
};

export const NavList = React.forwardRef<
  HTMLUListElement,
  PropsWithChildren<{}>
>((props, ref) => {
  const listChildren = React.Children.map(props.children, child => (
    <li>{child}</li>
  ));
  return (
    <ul ref={ref} className="nav-list">
      {listChildren}
    </ul>
  );
});
